import LoadingMoire from "../LoadingMoire";

const LoadingControlMixin = {
    isLoading: function()
    {
        return this._loadingControl;
    },

    setLoading: function(loading)
    {
        if (this._loadingControl !== loading)
        {
            this._loadingControl = loading;
            this._getLoadingControlMoire().toggle(loading);
        }
    },

    _getLoadingControlMoire: function()
    {
        if (!this._loadingControlMoire){
            this._loadingControlMoire = new LoadingMoire().init(this.$el)
        }
        return this._loadingControlMoire;
    }
};

export default LoadingControlMixin;


// WEBPACK FOOTER //
// ./web/js/controls/LoadingControlMixin.js